import { useEffect } from 'react';
import { useMapContext } from '../../context/MapContext';
import { TabsType } from '../../enums';
import { polygonDrawOptions } from '@/components/map/MapHelpers';

function processPoints(
  geometry: google.maps.LatLng | google.maps.Data.Geometry,

  callback: any,
  thisArg: google.maps.LatLngBounds
) {
  if (geometry instanceof google.maps.LatLng) {
    callback.call(thisArg, geometry);
  } else if (geometry instanceof google.maps.Data.Point) {
    callback.call(thisArg, geometry.get());
  } else {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    geometry.getArray().forEach((g) => {
      processPoints(g, callback, thisArg);
    });
  }
}
interface Props {
  map: google.maps.Map | null;
  selectedTab: string;
  isPolygonEditingDisabled?: boolean;
}

const useMapIndexPolygon = ({ map, selectedTab, isPolygonEditingDisabled = false }: Props) => {
  const { marketRectangleBounds, indexPolygon, setIndexPolygon } =
    useMapContext();

  const clearIndexPolygon = () => {
    map?.data.forEach((feature) => map.data.remove(feature));
  };

  useEffect(() => {
    // Clear index polygon when switching away from Price Development tab
    if (selectedTab !== TabsType.priceDevelopment && map) {
      // Clear the index polygon from context
      setIndexPolygon(null);
      // Remove all features from map.data (index polygon system)
      map.data.forEach((feature) => map.data.remove(feature));
    }
  }, [map, selectedTab, setIndexPolygon]);

  useEffect(() => {
    if (indexPolygon) {
      if (map) {
        map?.data.forEach((feature) => map.data.remove(feature));
        const features = map?.data.addGeoJson(indexPolygon);
        map?.data.setStyle({
          ...polygonDrawOptions,
          editable: !isPolygonEditingDisabled,
          draggable: !isPolygonEditingDisabled
        });
        const bounds = new google.maps.LatLngBounds();

        if (features.length > 0) {
          const geometry = features[0].getGeometry();
          if (geometry) {
            processPoints(geometry, bounds.extend, bounds);
            map.fitBounds(bounds);
          }
        }
      }
    }
  }, [indexPolygon, map, isPolygonEditingDisabled]);

  return { clearIndexPolygon };
};

export default useMapIndexPolygon;
